import React, { memo, forwardRef } from "react";
const SvgIntersection = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9 24a1 1 0 001-1v-7a6 6 0 0112 0v7a1 1 0 102 0v-7a8 8 0 10-16 0v7a1 1 0 001 1z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgIntersection.displayName = "SvgIntersection";
const MemoForwardRef = memo(SvgIntersection);
export default MemoForwardRef;
